import { SearchFormBase } from "mixs/base/form_mixin";
import { get } from "apps/actions/common"

class Search extends SearchFormBase {
  protected validKey(key){
    if(/^(o|s|w)$/.test(key)) return true;
    if(/^page$/.test(key)) return true;
    return false;
  }
  protected setParamsByKey(inputs, key, params){
    let value = inputs[key].value
    if(value == null || value == ''){
      // continue;
    }else if(
      (key == 'status' || key == 'delivery_options' || key == 'who') &&
      value.split(',').length == inputs[key].items.length
    ){
    } else {
      let name = inputs[key].name
      params[name] = inputs[key].value
    }
  }
}

riot.mixin("forms.tasks-deliveries.search", Search as riot.TagMixin);
